import SolicitacaoImportacao from './componentes/SolicitacaoImportacao.vue';
import SolicitacaoImportacaoLista from './componentes/SolicitacaoImportacaoLista.vue';
import SolicitacaoImportacaoForm from './componentes/SolicitacaoImportacaoForm.vue';
import SolicitacaoImportacaoRelatorio from './componentes/SolicitacaoImportacaoRelatorio.vue';

export default {
  path: '/solicitacao-importacao',
  component: SolicitacaoImportacao,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoImportacaoLista,
      name: 'solicitacao-importacao',
    },
    {
      path: 'nova',
      component: SolicitacaoImportacaoForm,
      name: 'solicitacao-importacao.nova'
    },
    ,
    {
      path: ':idCript',
      component: SolicitacaoImportacaoForm,
      name: 'solicitacao-importacao.editar'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoImportacaoRelatorio,
      name: 'solicitacao-importacao.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-importacao/rotas.js